import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import Loading from 'components/Loading';
import useAuthReady from 'utils/useAuthReady';
import { getReturnPath } from 'utils/returnPath';
import { PATHS } from '../../../constants';

const International: React.FC = () => {
  const location = useLocation();
  const { search } = location;
  const { loading, isLoggedIn, token } = useAuthReady();

  if (loading) {
    return <Loading />;
  }

  if (!token && !isLoggedIn) {
    return (
      <Navigate
        to={`${PATHS.INTERNATIONAL}/login${search}`}
        state={{ prevLocation: getReturnPath(location) }}
      />
    );
  }
  return <Outlet />;
};

export default International;
